import styled from 'styled-components';

interface Props {
  $color?: string;
}

export default styled.div<Props>`
  &&&& {
    color: ${({$color}) => $color || '#fff'};
  }
  line-height: 1.5;
  font-family: BurbankBigRegular-Black, sans-serif;
  text-transform: uppercase;
  font-size: 22px;
  text-align: left;
  @media screen and (max-width: 1200px) {
    text-align: center;
  }
`;
